module.exports = __webpack_public_path__ + "img/manual.7852e9f1.jpg";